// extracted by mini-css-extract-plugin
module.exports = {"modalExplain":"index_modalExplain__2Xfth","content":"index_content__22ggR","btnCon":"index_btnCon__1_XjH"};